import axios from 'axios'
import { i18n } from '../../plugins/i18n'

import {
  setFormValues,
  setFilterValues,
  toggleFilterValues
} from '../../modules/mutations.js'
import { castAttributesForCamelCase } from '../../modules/string_converter'

export const companiesProduct = {
  namespaced: true,
  state: {
    data: null,
    formValues: {
      stores: []
    },
    loading: false,
    productStores: [],
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    readProductSuccess(state, payload) {
      state.data = castAttributesForCamelCase(payload.data.attributes)
      state.formValues.stores = payload.data.attributes.product_stores.map(product_store => product_store.uuid)
      state.loading = false
    },
    apiSuccess(state) {
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    },
    initNewProduct(state) {
      state.data = {
        name: null,
        category_id: null,
      }
      state.formValues = {
        stores: []
      }
    },
    setProductStoresInfo(state, data) {
      const previewData = castAttributesForCamelCase(data)
      state.productStores = previewData.productStores
    },
    setFormValues,
    setFilterValues,
    toggleFilterValues
  },
  getters: {
    loading(state) {
      return state.loading
    },
    storeTotalCount(state) {
      return state.formValues.stores.length
    },
    productStores(state) {
      return state.productStores
    },
  },
  actions: {
    initNewProduct({ commit }) {
      commit('initNewProduct')
    },
    createProduct({ commit, rootState }, { payload }) {
      commit('prepareConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/products', payload)
        .then(() => {
          commit('apiSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.created', { value: i18n.t('models.product.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
    readProduct({commit, rootState}) {
      commit('prepareConnect')
      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/products/' + rootState.route.params.id)
        .then(res => {
          commit('readProductSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    updateProduct({ commit, rootState }, { payload}) {
      commit('prepareConnect')
      return axios
        .patch('/api/companies/' + rootState.route.params.company_uuid + '/products/' + rootState.route.params.id, payload)
        .then(() => {
          commit('apiSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updatedInfo', { value: i18n.t('models.product.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
    deleteProductStore({commit, rootState}, id) {
      commit('prepareConnect')
      return axios
        .delete('/api/companies/' + rootState.route.params.company_uuid + '/products/product_stores/' + id)
        .then(() => {
          commit('apiSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.deleted', { value: i18n.t('models.product.relation') }) }, { root: true })
          return true
        }).catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
    async createPreview({ rootState, commit }, { payload }) {
      commit('prepareConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/products/previews', payload)
        .then((res) => {
          commit('setProductStoresInfo', res.data.data)
          commit('apiSuccess')
          return true
        }).catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
  }
}
